<template>
    <div>
        <select @change="changeLangage" v-model="langage" v-if="$companyTool.confFile() && $companyTool.confFile().translates" test-id="translates-select" class="block w-full p-5 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none">
            <option v-for="(lang, langIndex) in langs" :key="'lang-' + langIndex" :value="lang.lang">{{lang.label}}</option>
        </select>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

export default {
    data() {
        return {
            langage: 'fr',
            langs: []
        }
    },

    methods: {
        changeLangage() {
            localStorage.setItem('langage', this.langage)
            location.reload()
        },

        async getAllLang() {
            let response = await apiService.post('getalllang', {})
            this.langs = response.data.posts.post
        }
    },

    async mounted() {
        await this.getAllLang()
        const lang = await this.$companyTool.getLang()
        this.langage = lang.lang
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/user/settings/AccountSettingsLangage.vue